import Toaster from "global/component/Genericos/Toaster/Toaster";
import { GlobalContext } from "global/context/Provider";
import { useContext, useState } from "react";
import { useHistory } from "react-router";
import CirculoTildeOk from "_+_Portal/assets/images/generico/CirculoTildeOk";
import CardBlueHeart from "_+_Portal/_-_Autocheckin/components/genericos/CardBlueHeart/CardBlueHeart";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { wsPostFilaVirtual } from "_+_Portal/_-_Autocheckin/context/action/filaVirtual";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import {
  ContainerFilaVirtual,
  FilaVirtualBotones,
  FilaVirtualConoceMasTxt,
  FilaVirtualIcono,
  FilaVirtualTitulo,
  FilaVirtualTxt,
} from "./localStyle";
import ToasterV2 from "global/component/Genericos/Toaster/ToasterV2";

const FilaVirtual = ({ setError, turnoActual }) => {
  // -------------------------  useContex  ----------------------------
  const {
    turnosAutoCheckInState,
    pasoDispatch,
    turnosSeleccionadosState,

    demoraState,
    filaVirtualDispatch,
    textosAutoCheckinState,
  } = useContext(AutocheckContext);
  const { toasterState, authState } = useContext(GlobalContext);

  // -------------------------  useContex  ----------------------------

  // -------------------------  constants  ----------------------------

  const listTurnosSeleccionado =
    turnosSeleccionadosState.turnosSeleccionados.data;

  const turno = listTurnosSeleccionado[turnoActual];

  const medico = turno.medico;
  const especialidad = turno.especialidad;

  let initialData = turnosAutoCheckInState.turnosAutoCheckIn.data;
  if (initialData !== false) {
    initialData = initialData.filter((e) => !e.presente);
  }

  // -------------------------  constants  ----------------------------

  // -------------------------  useStates  ----------------------------

  // -------------------------  useStates  ----------------------------

  // -------------------------  funciones  ----------------------------
  const volver = () => {
    setPaso("Home")(pasoDispatch);
  };
  const handleClickMasInfo = () => {
    setPaso("FilaVirtualMasInfo")(pasoDispatch);
  };

  const callBack = (isCorrect) => {
    if (isCorrect) {
      setPaso("FilaVirtualCasa")(pasoDispatch);
    }
  };

  const ingresarFilaVirtual = () => {
    let dtoFilaVirtual = {
      idpaciente: authState.auth.data.paciente.codigo,
      idturno: turno.idturno,
      demorainicial: demoraState.demora.data.demora,
    };
    wsPostFilaVirtual(dtoFilaVirtual, (isCorrect) => callBack(isCorrect))(
      filaVirtualDispatch
    );
  };
  const cancelarFilaVirtual = () => {
    setPaso("TurnosRecepionados")(pasoDispatch);
  };

  // -------------------------  funciones  ----------------------------

  return (
    <LayoutPasos handleClick={volver} type={"no-circle"} title={"FILA VIRTUAL"}>
      {toasterState.toaster.show && <ToasterV2 />}
      <ContainerFilaVirtual>
        <CardBlueHeart
          medico={medico ? medico : especialidad}
          turnoTitle={especialidad}
          pasoActual={turnoActual + 1}
          pasoTotal={listTurnosSeleccionado.length}
        />
        <FilaVirtualTitulo>
          <span className="rb24b">¡Terminamos!</span>
        </FilaVirtualTitulo>
        <FilaVirtualIcono>
          <CirculoTildeOk width={90} height={90} />
        </FilaVirtualIcono>

        <FilaVirtualTxt>
          <span className="rb18l">
            {
              textosAutoCheckinState.textosAutoCheckin.data.colaVirtualPregunta
                .descripcion
            }
          </span>
        </FilaVirtualTxt>
        <FilaVirtualConoceMasTxt>
          <span
            onClick={handleClickMasInfo}
            className="FilaVirtualConoceMasTxt rb18b"
          >
            Toca acá para conocer más
          </span>
        </FilaVirtualConoceMasTxt>
        <FilaVirtualBotones>
          <div
            className="btn bgc-broccoli c-white"
            onClick={ingresarFilaVirtual}
          >
            Si
          </div>
          <div className="btn bgc-danger c-white" onClick={cancelarFilaVirtual}>
            No
          </div>
        </FilaVirtualBotones>
      </ContainerFilaVirtual>
    </LayoutPasos>
  );
};

export default FilaVirtual;
